import { useState } from 'react'
import Ladehinweis from '../../komponenten/Ladehinweis'
import { useLaden, zeitpunktText } from '../../lib/laden'
import {
  ENTSCHEIDUNG_TEXT,
  ZIEL_TEXT,
  holeJournal,
  type Journaleintrag,
} from '../../lib/kennzahlen'

/**
 * Wer hat wann was entschieden — und warum?
 *
 * `core_decision` wird bei jeder Freigabe geschrieben und war bisher nur per
 * SQL erreichbar. Sobald jemand fragt „warum wurde mein Foto abgelehnt", ist
 * das die einzige Quelle.
 */

const ZIELARTEN = ['', 'media', 'review', 'submission', 'report', 'place']
const ENTSCHEIDUNGEN = ['', 'accepted', 'rejected', 'reverted', 'auto_approved']

export default function Journal() {
  const [zielArt, setZielArt] = useState('')
  const [entscheidung, setEntscheidung] = useState('')
  const [zustand] = useLaden(
    () => holeJournal({ zielArt, entscheidung }),
    [zielArt, entscheidung],
  )

  return (
    <section className="stapel">
      <div className="stapel-kopf">
        <h1>Entscheidungsjournal</h1>
        {zustand.art === 'da' && (
          <p className="gedaempft zahl">
            {zustand.wert.eintraege.length} Einträge
            {zustand.wert.eintraege.length === 200 && (
              <span className="leise"> · gedeckelt</span>
            )}
          </p>
        )}
      </div>

      <div className="karte filterzeile">
        <label className="feld">
          <span>Art</span>
          <select value={zielArt} onChange={(e) => setZielArt(e.target.value)}>
            {ZIELARTEN.map((z) => (
              <option key={z} value={z}>
                {z === '' ? 'alle' : (ZIEL_TEXT[z] ?? z)}
              </option>
            ))}
          </select>
        </label>
        <label className="feld">
          <span>Entscheidung</span>
          <select value={entscheidung} onChange={(e) => setEntscheidung(e.target.value)}>
            {ENTSCHEIDUNGEN.map((z) => (
              <option key={z} value={z}>
                {z === '' ? 'alle' : (ENTSCHEIDUNG_TEXT[z] ?? z)}
              </option>
            ))}
          </select>
        </label>
        <p className="leise">Die letzten 90 Tage, höchstens 200 Einträge.</p>
      </div>

      {zustand.art !== 'da' ? (
        <Ladehinweis zustand={zustand} />
      ) : zustand.wert.eintraege.length === 0 ? (
        <div className="karte">
          <p className="gedaempft">Keine Entscheidung passt zu diesem Filter.</p>
        </div>
      ) : (
        <div className="karte">
          <div className="tabelle-huelle">
            <table className="tabelle">
              <thead>
                <tr>
                  <th>Wann</th>
                  <th>Was</th>
                  <th>Entscheidung</th>
                  <th>Betrifft</th>
                  <th>Von</th>
                  <th>Begründung</th>
                </tr>
              </thead>
              <tbody>
                {zustand.wert.eintraege.map((e) => (
                  <Zeile key={`${e.target_kind}:${e.target_id}:${e.decided_at}`} e={e} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  )
}

function Zeile({ e }: { e: Journaleintrag }) {
  return (
    <tr>
      <td className="leise">{zeitpunktText(e.decided_at)}</td>
      <td>
        {ZIEL_TEXT[e.target_kind] ?? e.target_kind}
        {e.domain && <span className="leise"> · {e.domain}</span>}
        {e.was_sampled && <span className="leise"> · Stichprobe</span>}
      </td>
      <td>
        <strong className={e.decision === 'rejected' ? 'wort-ab' : 'wort-frei'}>
          {ENTSCHEIDUNG_TEXT[e.decision] ?? e.decision}
        </strong>
      </td>
      <td>
        {e.betrifft ?? (
          <span className="leise">
            {e.betrifft_uid ? `Anonym · ${e.betrifft_uid.slice(0, 6)}` : '—'}
          </span>
        )}
      </td>
      <td>
        {/* Der Unterschied zwischen „niemand" und „nicht mehr feststellbar"
            ist genau der, um den es in einem Journal geht. */}
        {e.entschieden_von ?? <span className="leise">unbekannt</span>}
      </td>
      <td className="leise journal-grund">{e.reason ?? '—'}</td>
    </tr>
  )
}
